import { Wallet, TrendingUp, Activity, Loader2, Plus } from "lucide-react";

const fmt = (n, dp = 2) =>
  n != null && Number.isFinite(+n)
    ? Number(n).toLocaleString(undefined, {
        minimumFractionDigits: dp,
        maximumFractionDigits: dp,
      })
    : "—";

const BalanceCard = ({ balance, accountId, connState, onAddFunds }) => {
  const isLive = connState === "live";
  const isDemo = connState === "demo";
  const isConnecting = connState === "connecting";
  const isVrtcDemo = accountId?.startsWith?.("VRTC");

  return (
    <div
      data-testid="balance-card"
      className="vts-card p-5 sm:p-6 lg:p-7 flex flex-col sm:flex-row gap-5 sm:gap-6 sm:items-center sm:justify-between"
    >
      <div className="flex items-center gap-4 sm:gap-5 min-w-0">
        <div className="h-12 w-12 rounded-md bg-vts-blue/15 border border-vts-blue/30 flex items-center justify-center shrink-0">
          <Wallet className="h-5 w-5 text-vts-blue" />
        </div>
        <div className="min-w-0">
          <div className="text-[10px] sm:text-xs uppercase tracking-[0.2em] text-vts-silver/60 mb-1">
            Account balance
          </div>
          <div className="flex items-baseline gap-2 sm:gap-3">
            <span
              data-testid="balance-amount"
              className="font-mono text-2xl sm:text-3xl lg:text-4xl font-medium text-white tabular-nums"
            >
              {isConnecting ? (
                <Loader2 className="h-6 w-6 animate-spin text-vts-silver/40 inline-block" />
              ) : (
                fmt(balance?.balance, 2)
              )}
            </span>
            <span className="text-xs sm:text-sm font-mono text-vts-silver">
              {balance?.currency || "USD"}
            </span>
          </div>
          <div className="mt-1 text-[10px] sm:text-[11px] text-vts-silver/50 font-mono truncate">
            <span className="truncate">{accountId || "—"}</span>
            {(isDemo || isVrtcDemo) && (
              <span
                data-testid="balance-demo-badge"
                className="ml-2 inline-block px-1.5 py-0.5 rounded bg-vts-blue/15 text-vts-blue border border-vts-blue/40 text-[9px] uppercase tracking-wider"
              >
                Demo
              </span>
            )}
          </div>
        </div>
      </div>

      <div className="flex items-center gap-6 sm:gap-8 lg:gap-10 flex-wrap">
        <div>
          <div className="text-[10px] uppercase tracking-wider text-vts-silver/50 mb-1">
            Today
          </div>
          <div className="flex items-center gap-1.5 font-mono text-sm sm:text-base text-vts-profit tabular-nums">
            <TrendingUp className="h-3.5 w-3.5" /> +0.00%
          </div>
        </div>
        <div>
          <div className="text-[10px] uppercase tracking-wider text-vts-silver/50 mb-1">
            Status
          </div>
          <div className="flex items-center gap-1.5 font-mono text-sm sm:text-base text-white">
            <Activity
              className={`h-3.5 w-3.5 ${
                isLive ? "text-vts-profit" : isDemo ? "text-vts-blue" : "text-vts-silver/60"
              }`}
            />
            {isLive ? "Active" : isDemo ? "Demo" : "…"}
          </div>
        </div>
        {onAddFunds && (
          <button
            data-testid="balance-add-funds-btn"
            onClick={onAddFunds}
            className="flex items-center gap-1.5 rounded-lg bg-amber-400 text-black font-bold text-[13px] px-4 py-2.5 hover:brightness-110 active:scale-95 transition shrink-0"
            title="Deposit on Deriv → transfer to your Options account"
          >
            <Plus className="h-4 w-4" /> Add funds
          </button>
        )}
      </div>
    </div>
  );
};

export default BalanceCard;
